import { Box, Button, PackageIcon, Stack, Text, useColorModeValue as mode } from '@chaine/keychaine';
import moment from 'moment';
import React from 'react';
import { NavLink } from 'react-router-dom';
import * as Logos from '../_images/brands';
import { ROUTES } from '../_routes';
import { subtleGradients } from '../_shared/gradients';
import { LogoCarousel } from '../_shared/logo-carousel';
import { MapMessageIcon, MapWithRoute } from '../product';
const glowEffectStyleDark = {
    _before: {
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 0,
        filter: 'blur(80px)',
        transform: 'scale(2)',
        opacity: 0.4
    },
    background: 'radial-gradient(40.07% 37.09% at 50% 50%, #01003E 0%, rgba(1, 0, 158, 0.36) 43.68%, rgba(3, 3, 142, 0.00) 150%)'
};
const glowEffectStyleLight = {
    _before: {
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 0,
        filter: 'blur(80px)',
        transform: 'scale(2)',
        opacity: 0.4
    },
    background: 'radial-gradient(40.07% 37.09% at 50% 50%, #F0G0F0 0%, rgba(240, 240, 240, 0.36) 43.68%, rgba(255, 255, 255, 0.10) 100%)'
};
export const Hero = () => {
    const time = moment().add(272, 'minutes').format('h:mm A');
    const glowEffectStyle = mode(glowEffectStyleLight, glowEffectStyleDark);
    return (React.createElement(Box, { bg: mode(subtleGradients.blue, undefined) },
        React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", sx: { ...glowEffectStyle }, overflow: "visible" },
            React.createElement(Box, { borderColor: mode('text.light.primary', 'white'), pt: "10rem", width: "fit-content" },
                React.createElement(Box, null,
                    React.createElement(Box, { textAlign: "center" },
                        React.createElement(Text, { fontSize: { base: '3.0rem', md: '3.5rem', lg: '4.5rem' }, fontWeight: "bold", mx: "auto", lineHeight: "1.2", letterSpacing: "tight", color: "text.primary" },
                            "AI-powered freight booking and visibility.",
                            React.createElement("br", null)),
                        React.createElement(Text, { fontSize: { base: '2xl', md: '3xl', lg: '4xl' }, mt: "4", maxW: "48rem", mx: "auto", fontWeight: "regular" }, "To network, book, and track freight automatically.")),
                    React.createElement(Stack, { justify: "center", direction: { base: 'column', md: 'row' }, mt: "10", mb: "0", spacing: "4" },
                        React.createElement(Button, { as: "a", href: "#", size: "lg", variant: "primary", px: "8", fontWeight: "bold", fontSize: "md" },
                            React.createElement(NavLink, { to: ROUTES.TALK_TO_SALES.href }, "Talk to sales")))),
                React.createElement(Box, { display: "flex", justifyContent: "center" },
                    React.createElement(Box, { className: "group", cursor: "pointer", position: "relative", overflow: "visible", w: { base: '80%', md: '60%', lg: '60%' }, height: { base: 'xs', md: 'sm', lg: 'md' }, my: 8 },
                        React.createElement(MapWithRoute, { id: "hero-map", leftComponent: React.createElement(MapMessageIcon, { message: `ETA ${time}`, mx: { base: '-12', md: '-16' } }), rightComponent: React.createElement(MapMessageIcon, { icon: PackageIcon, iconColor: mode('green.500', 'green.400'), message: `12 reloads nearby`, mx: { base: '280', md: '450', lg: '500', xl: '650' }, mt: { base: -6, md: -20, lg: -20 } }), initialViewPort: 'currentLocation', showAvailableLoads: true }))))),
        React.createElement(Box, { as: "section" },
            React.createElement(Box, { mt: 6, maxW: { base: 'xl', md: '7xl' }, mx: "auto", px: { base: '6', md: '8' }, display: "flex", justifyContent: "center" },
                React.createElement(LogoCarousel, { logos: [
                        React.createElement(Logos.Salesforce, { key: "Salesforce" }),
                        React.createElement(Logos.PriorityOne, { key: "PriorityOne" }),
                        React.createElement(Logos.MercuryGate, { key: "MercuryGate" }),
                        React.createElement(Logos.DLX, { key: "DLX" }),
                        React.createElement(Logos.JTS, { key: "JTS" }),
                        React.createElement(Logos.Bedrock, { key: "Bedrock" }),
                        React.createElement(Logos.Greatlakes, { key: "Greatlakes" }),
                        React.createElement(Logos.PriorityOne, { key: "PriorityOne-1" }),
                        React.createElement(Logos.ThreeGTMS, { key: "ThreeGTMS-1" }),
                        React.createElement(Logos.Salesforce, { key: "Salesforce-2" }),
                        React.createElement(Logos.TaiTMS, { key: "TaiTMS" }),
                        React.createElement(Logos.Bedrock, { key: "Bedrock-1" }),
                        React.createElement(Logos.DLX, { key: "DLX-1" }),
                        React.createElement(Logos.Revenova, { key: "Revenova" }),
                        React.createElement(Logos.XTMS, { key: "XTMS" }),
                        React.createElement(Logos.Greatlakes, { key: "Greatlakes-1" })
                    ] })))));
};
